

<div class="acquisition_top" style="display:block;">
  <!-- top left part  -->


  <!-- top right part -->

  <div class="filter_search">
    <div class="search_container">
      <input type="text"  #search class="default_input search search_land" placeholder="Search" />
      <i class="ti-search"></i>
    </div>
    <button class="default_secondary-btn filter" (click)="onFilter()">Filter <i class="ti-filter"></i></button>
    <button class="default_secondary-btn Add_new" (click)="createEvent()">Create New<i class="ti-plus"></i></button>
  </div>
</div>

